<div
  class="toast-container"
  *ngIf="show"
  [class.error]="type === 'error'"
  [class.success]="type === 'success'"
  [class.warning]="type === 'warning'"
  [class.info]="type === 'info'"
  [attr.role]="type === 'error' ? 'alert' : 'status'"
  [attr.aria-live]="type === 'error' ? 'assertive' : 'polite'">
  <div class="toast-content">
    <div class="toast-icon" aria-hidden="true" *ngIf="type === 'error'">
      <img src="assets/agricola/toast-warning.svg" alt="" class="toast-warning-icon">
    </div>
    <div class="toast-icon" aria-hidden="true" *ngIf="type !== 'error'">
      <i [class]="getIconClass()" aria-hidden="true"></i>
    </div>
    <div class="toast-message">
      {{ message }}
    </div>
    <button class="toast-close" type="button" aria-label="Cerrar mensaje" (click)="onClose()">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>
</div>
